/**
 * Delete Jabatan Dialog Component
 * 
 * Confirmation dialog for deleting jabatan.
 */

import * as React from "react";
import {
  AlertDialog,
  AlertDialogAction,
  AlertDialogCancel,
  AlertDialogContent,
  AlertDialogDescription,
  AlertDialogFooter,
  AlertDialogHeader,
  AlertDialogTitle,
} from "@/components/ui/alert-dialog";
import { Loader2 } from "lucide-react";
import type { Jabatan } from "@/services/managementService";

interface DeleteJabatanDialogProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  jabatan: Jabatan | null;
  onConfirm: () => Promise<void>;
}

export function DeleteJabatanDialog({
  open,
  onOpenChange,
  jabatan,
  onConfirm,
}: DeleteJabatanDialogProps) {
  const [deleting, setDeleting] = React.useState(false);

  const handleConfirm = async () => {
    if (!jabatan) return;

    setDeleting(true);
    try {
      await onConfirm();
      onOpenChange(false);
    } catch (error) {
      console.error("Error deleting jabatan:", error);
    } finally {
      setDeleting(false);
    }
  };

  if (!jabatan) return null;

  return (
    <AlertDialog open={open} onOpenChange={onOpenChange}>
      <AlertDialogContent>
        <AlertDialogHeader>
          <AlertDialogTitle>Hapus Jabatan?</AlertDialogTitle>
          <AlertDialogDescription>
            Apakah Anda yakin ingin menghapus jabatan <strong>{jabatan.name}</strong>?
            Tindakan ini tidak dapat dibatalkan.
          </AlertDialogDescription>
        </AlertDialogHeader>
        <AlertDialogFooter>
          <AlertDialogCancel disabled={deleting}>Batal</AlertDialogCancel>
          <AlertDialogAction
            onClick={handleConfirm}
            disabled={deleting}
            className="bg-red-600 hover:bg-red-700"
          >
            {deleting && <Loader2 className="mr-2 h-4 w-4 animate-spin" />}
            Hapus
          </AlertDialogAction>
        </AlertDialogFooter>
      </AlertDialogContent>
    </AlertDialog>
  );
}

